export default {
  errors: {
    wrong_brn_format: "หมายเลข BRN ไม่ถูกต้อง",
    db_query_failed: "เชื่อมต่อฐานข้อมูลผิดพลาด",
    db_fetch_failed: "การอ่านข้อมูลจากฐานข้อมูลผิดพลาด",
    permission_denied: "คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้",
    // msw: "การเชื่อมต่อ MSw API ล้มเหลว",
    msw_unknown_result: "ไม่สามารถอ่านข้อมูลจาก MSw API",
    invalid_param: "ข้อมูลที่ระบุไม่ถูกต้อง",
    invalid_date: "ข้อมูลวันที่ไม่ถูกต้อง",
    invalid_date_range:
      "ข้อมูลช่วงวันที่ไม่ถูกต้อง กรุณาเลือกช่วงวันที่ไม่เกิน 31 วัน",
    invalid_date_range_over_60: "ช่วงเวลาที่เลือกเกิน 60 วัน",
    invalid_date_range_over_90: "ช่วงเวลาที่เลือกเกิน 90 วัน",
    invalid_keyword_number: "ข้อมูลหมายเลขไม่ถูกต้อง",
    twofa_code: "OTP ผิดพลาด ({0})",
    twofa: {
      S_AUT_00000: "OTP ผิดพลาด (S_AUT_00000)",
      B_AUT_00001: "User name หรือ Password ไม่ถูกต้อง",
      B_AUT_00002: "Password ไม่ถูกต้อง",
      B_AUT_00402: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_AUT_00403: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_AUT_00404: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_AUT_99999: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00101: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00102: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00103: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00405: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00503:
        "ขณะนี้ระบบกำลังอยู่ระหว่างการปิดปรับปรุง รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00901: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00902: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_99999: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00101: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_AUT_00102: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_00403: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_00404: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_00406: "เบอร์สำหรับรับ OTP ไม่ถูกต้อง",
      B_SRV_00410: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61001: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61002: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61003: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61004: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      B_SRV_61005: "เบอร์รับ OTP ถูกระงับการใช้บริการ",
      B_SRV_61006: "เบอร์สำหรับรับ OTP ไม่ถูกต้อง",
      B_SRV_61007: "ระบบถูกล็อค กรุณาทำรายการใหม่ในอีก 15 นาทีถัดไป",
      B_SRV_61009: "รหัส OTP ไม่ถูกต้อง กรุณาทำรายการใหม่อีกครั้งค่ะ",
      B_SRV_61010: "รหัส OTP หมดอายุ กรุณาทำรายการใหม่อีกครั้งค่ะ",
      B_SRV_61011: "รหัส OTP ไม่ถูกต้อง กรุณาทำรายการใหม่อีกครั้งค่ะ",
      B_SRV_61012: "ใส่ OTP ผิดเกิน 3 ครั้ง",
      B_SRV_61013: "รหัส OTP ไม่ถูกต้อง กรุณาทำรายการใหม่อีกครั้งค่ะ",
      B_SRV_99999: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00101: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00102: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00103: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00405: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00503:
        "ขณะนี้ระบบกำลังอยู่ระหว่างการปิดปรับปรุง รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00901: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00902: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00904: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00905: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00906: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00907: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00908: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00909: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00910: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13001: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13003: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13004: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13005: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13006: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13002: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_13000: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_99999: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00101: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_SRV_00102: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_ESV_00401: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_ESV_00498: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ",
      T_ESV_00502: "ขณะนี้ระบบไม่สามารถทำรายการได้ รบกวนทำรายการใหม่ภายหลังค่ะ"
    },
    msw: {
      numberblock_add_failed: "เพิ่ม Number Block ไม่ได้",
      number_create_failed:
        "ไม่สามารถสร้างหรือเพิ่มหมายเลขโทรศัพท์นี้ในระบบได้",
      number_delete_failed: "ไม่สามารถลบหมายเลขโทรศัพท์นี้ออกจากระบบได้",
      delete_pirot_dummy_failed: "ไม่สามารถลบหมายเลขนำหมู่ออกจากระบบได้",
      voicemail_failed: "ไม่สามารถประมวลผลข้อมูลข้อความเสียง"
    },
    dtac: {
      idcard_validate_fail: "ไม่พบข้อมูล BRN นี้",
      subs_query_status_failed:
        "ไม่พบข้อมูลของหมายเลขโทรศัพท์นี้ในระบบของดีแทค",
      subs_query_package_failed: "ไม่พบข้อมูลของแพ็กเกจนี้ในระบบของดีแทค",
      wci_failed: "ไม่สามารถสร้างหรือเพิ่มหมายเลขโทรศัพท์นี้ได้",
      unknown_result: "ไม่สามารถอ่านข้อมูลจาก DTAC API",
      wci_queue: "การสร้างหมายเลขอยู่ในคิว"
    },
    user: {
      duplicate: "ข้อมูลผู้ใช้งานซ้ำ",
      duplicate_username: "ข้อมูลผู้ใช้งานซ้ำ",
      duplicate_email: "ข้อมูลอีเมล์ซ้ำ",
      blcok_delete_by_self: "ไม่สามารถลบข้อมูลตนเองได้",
      fail: "การปรับปรุงข้อมูลผู้งานผิดพลาด",
      email_wrong_format: "รูปแบบอีเมล์ไม่ถูกต้อง",
      enterprise_empty: "กรุณาระบุองค์กร",
      name_empty: "กรุณาชื่อผู้ใช้งาน",
      phone_wrong_format: "หมายเลขโทรศัพท์ไม่ถูกต้อง"
    },
    corp: {
      wrong_type: "ประเภทองค์กรไม่ถูกต้อง",
      wrong_format: "รูปแบบชื่อองค์กรไม่ถูกต้อง",
      duplicate: "ข้อมูลองค์กรซ้ำ",
      not_exist: "ไม่พบข้อมูลองค์กร",
      check_number_fail: "การตรวจสอบหมายเลขผิดพลาด",
      number_exist: "มีหมายเลขที่ใช้งานอยู่ในองค์กร",
      failed: "การปรับปรุงข้อมูลองค์กรผิดพลาด",
      create_failed: "สร้างข้อมูลองค์กรผิดพลาด",
      delete_failed: "ลบข้อมูลองค์กรผิดพลาด",
      user_exist: "มีผู้ใช้งานอยู่ในองค์กร"
    },
    mlhg: {
      duplicate: "ข้อมูลกลุ่ม Hunt ซ้ำ",
      get_dummy_number_fail: "ไม่พบข้อมูลหมายเลขนำหมู่",
      not_exist: "ไม่พบข้อมูลกลุ่ม Hunt",
      member_not_exist: "ไม่พบข้อมูลหมายเลขในกลุ่ม Hunt",
      member_not_in_corp: "ไม่มีหมายเลขนี้ในองค์กร",
      get_enterprise_fail: "ไม่พบข้อมูลองค์กร",
      get_mlhg_fail: "ไม่พบข้อมูลกลุ่ม Hunt",
      get_number_fail: "ไม่พบข้อมูลหมายเลข",
      get_pilot_fail: "ไม่พบข้อมูลหมายเลขนำหมู่",
      update_number_fail: "แก้ไขข้อมูลหมายเลขผิดพลาด",
      delete_number_fail: "การลบข้อมูลหมายเลขผิดพลาด",
      redeem_dummy_pilot_failed: "ไม่สามารถคืนหมายเลขนำหมู่",
      number_duplicate: "มีหมายเลขนี้แล้วในกลุ่ม Hunt",
      access_denie: "ผู้ใช้งานไม่มีสิทธิ์ในการเข้าถึงข้อมูลนี้"
    },
    auth: {
      login_fail: "เข้าสู่ระบบผิดพลาด",
      block: "ผู้ใช้งานถูกระงับ",
      login_success: "เข้าสู่ระบบสำเร็จ",
      logout_success: "ออกจากระบบสำเร็จ",
      unauthoriezed: "เข้าสู่ระบบผิดพลาด",
      reset_invalid_token: "token ไม่ถูกต้อง",
      reset_token_expired: "token หมดอายุ",
      forgot_password_fail: "ลืมรหัสผ่านไม่สำเร็จ",
      reset_password_fail: "เปลี่ยนรหัสผ่านไม่สำเร็จ",
      username_wrong_format: "รูปแบบของชื่อผู้ใช้งานไม่ถูกต้อง",
      password_wrong_format: "รูปแบบของรหัสผ่านไม่ถูกต้อง",
      token: "Toekn ไม่ถูกต้อง",
      password: "รหัสผ่านไม่ถูกต้อง",
      password_confirm: "การยืนยันรหัสผ่านไม่ถูกต้อง",
      request_twofa_fail: "การขอรหัส OTP ผิดพลาด",
      verify_twofa_fail: "การยืนยัน OTP ผิดพลาด"
    },
    otp: {
      request_otp_fail: "การขอรหัส OTP ผิดพลาด",
      verify_otp_fail: "การยืนยัน OTP ผิดพลาด"
    },
    package: {
      duplicate_code: "รหัสแพ็คเกจซ้ำ",
      duplicate_name: "ชื่อแพ็คเกจซ้ำ",
      not_exist: "ไม่พบข้อมูลแพ็คเกจ",
      delete_lock: "ไม่สามารถลบข้อมูลแพ็คเกจได้ เนื่องจากมีการใช้งาน",
      get_profile_failed: "ไม่พบข้อมูลของแพ็กเกจ VPBX ในระบบ"
    },
    subs: {
      invalid_number: "รูปแบบหมายเลขไม่ถูกต้อง",
      invalid_mapping_number: "รูปแบบหมายเลข Mapping ไม่ถูกต้อง",
      invalid_agent_number: "รูปแบบหมายเลขผู้ใช้งานไม่ถูกต้อง",
      invalid_main_number: "รูปแบบหมายเลของค์กรไม่ถูกต้อง",
      invalid_charge_number: "รูปแบบหมายเลขที่คิดค่าใช้จ่ายไม่ถูกต้อง",
      invalid_alt_number: "รูปแบบหมายเลข Alternative ไม่ถูกต้อง",
      invalid_real_number: "รูปแบบหมายเลข Real ไม่ถูกต้อง",
      invalid_additional_number: "รูปแบบหมายเลข Additional ไม่ถูกต้อง",
      invalid_email: "รูปแบบอีเมล์ไม่ถูกต้อง",
      not_exist: "ไม่พบหมายเลขนี้",
      corp_not_match: "ข้อมูลองค์กรไม่ถูกต้อง",
      get_crop_id_failed: "ไม่พบข้อมูลองค์กรหรือหมายเลของค์กร",
      comp_login_failed: "ไม่สามารถเข้าสู่ระบบ ComPortal ได้",
      duplicate: "หมายเลขซ้ำ",
      get_charge_number_failed: "ไม่พบข้อมูลหมายเลขโทรศัพท์ภายใต้บริษัทนี้",
      set_charge_number_failed: "ไม่สามารถเปลี่ยนข้อมูลหมายเลขนี้",
      get_brn_failed: "ไม่พบข้อมูลหมายเลข BRN",
      is_mlhg_member: "หมายเลขนี้เป็นสมาชิกของกลุ่ม Hunt",
      number_range_delete_fail: "ไม่สามารถลบข้อมูลช่วงหมายเลข",
      comp_login_failed: "เข้าสู่ระบบ ComPortal ผิดพลาด",
      idcard_validate_fail: "ข้อมูลหมายเลขไม่ถูกต้อง",
      subs_status_failed: "หมายเลขนี้ไม่มีสิทธิ์สมัครบริการนี้",
      import_number: "อัพโหลดหมายเลขผู้ใช้งานผิดพลาด",
      reset_password_fail: "รีเซ็ตรหัสผ่านผิดพลาด",
      delete_failed: "ลบหมายเลขผิดพลาด",
      delete_number_block_failed: "ลบ Number Block ผิดพลาด",
      number_in_mlhg: "หมายเลขนี้ถูกใช้งานในกลุ่ม Hunt"
    },
    profile: {
      get_profile_failed: "เรียกข้อมูลผู้ใช้งานผิดพลาด",
      change_profile_failed: "แก้ไขข้อมูลผิดพลาด",
      change_password_failed: "แก้ไขรหัสผ่านผิดพลาด",
      password_confirm_not_match: "การยืนยันรหัสผ่านไม่ถูกต้อง",
      password_confirm_wrong_format: "รูปแบบรหัสผ่านไม่ฟถูกต้อง",
      password_old_wrong: "รหัสผ่านเดิมไม่ถูกต้อง"
    },
    report: {
      date_over_60: "ช่วงเวลาที่เลือกเกิน 60 วัน",
      date_over_90: "ช่วงเวลาที่เลือกเกิน 90 วัน",
      date_over_30:
        "ไม่สามารถค้นหาข้อมูลได้เกิน 60 วัน และถ้าค้นหาข้อมูลมากกว่า 30 วันการค้นหาอาจจะเกิดความล่าช้า"
    }
  },

  bc_portal: "Web Portal",
  bc_package: "แพ็คเกจ",
  bc_voicemail: "ข้อความเสียง",
  bc_report: "รายงานการโทร",
  bc_record: "ข้อมูลการโทร",
  bc_user: "ผู้ใช้งาน",
  bc_corporate: "องค์กร",
  bc_mlhg: "กลุ่ม Hunt",
  bc_pilot_number: "หมายเลของค์กร",
  bc_agent_number: "หมายเลขผู้ใช้งาน",
  bc_mapping_number: "หมายเลข mapping",
  bc_import_number: "นำเข้าหมายเลขผู้ใช้งาน",
  bc_change_profile: "ข้อมูลส่วนตัว",
  bc_change_password: "เปลี่ยนรหัสผ่าน",

  profile: {
    profile: "ข้อมูลส่วนตัว",
    name: "ชื่อ",
    phone: "เบอร์โทรศัพท์",
    email: "อีเมล์",
    change_password: "เปลี่ยนรหัสผ่าน",
    password_old: "รหัสผ่านเดิม",
    password_new: "รหัสผ่านใหม่",
    password_confirm: "ยืนยันรหัสผ่าน",
    change_profile_success: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
    change_password_success: "เปลี่ยนรหัสผ่านสำเร็จ"
  },
  menu: {
    corporate: "องค์กร",
    mlhg: "กลุ่ม Hunt",
    package: "แพ็คเกจ",
    pilot_number: "หมายเลของค์กร",
    agent_number: "หมายเลขผู้ใช้งาน",
    import_agent_number: "นำเข้าหมายเลขผู้ใช้งาน",
    number: "หมายเลข",
    user: "ผู้ใช้งาน",
    voicemail: "ข้อความเสียง",
    cdr: "ข้อมูลการโทร",
    report: "รายงานการโทร",
    nseries: "การประชุมผ่านโทรศัพท์"
  },
  auth: {
    signin: "เข้าสู่ระบบ",
    signout: "ออกจากระบบ",
    username: "อีเมล์หรือหมายเลขผู้ใช้งาน",
    email: "อีเมล์",
    password: "รหัสผ่าน",
    forgetpassword: "ลืมรหัสผ่าน",
    resetpassword: "รีเซ็ตพาสเวิร์ด",
    confirm_reset_password: "ยืนยันการรีเซ็ตพาสเวิร์ดหมายเลข ",
    forgot_password_success: "ลืมรหัสผ่านสำเร็จ กรุณาตรวจสอบอีเมล์",
    reset_password_success: "เปลี่ยนรหัสผ่านสำเร็จ",

    twofa: "ยืนยันรหัส OTP",
    twofa_send_to: "รหัส OTP ของคุณถูกส่งไปยังหมายเลข {0}",
    otp_ref_code: "(รหัสอ้างอิง OTP : {0})",
    refcode: "รหัสอ้างอิง",
    otpcode: "รหัส OTP",
    requestotp: "ขอรหัส OTP",
    requestnewotp: "ขอรหัส OTP ใหม่ใน {0} วินาที"
  },
  corp: {
    name: "ชื่อองค์กร",
    brn: "BRN",
    code: "หมายเลของค์กร",
    create: "สร้างองค์กร",
    create_success: "สร้างองค์กรสำเร็จ",
    create_fail: "สร้างองค์กรไม่สำเร็จ"
  },
  package: {
    name: "ชื่อแพ็คเกจ",
    code: "หมายเลขแพ็คเกจ",
    create: "สร้างแพ็คเกจ",
    profile: "Persistent Profile",
    cos: "Class Of Service",
    create_success: "สร้างแพ็คเกจสำเร็จ",
    create_fail: "สร้างแพ็คเกจไม่สำเร็จ"
  },
  number: {
    add: "เพิ่มหมายเลข",
    type: "ประเภทหมายเลข",
    pilot: "หมายเลของค์กร",
    agent: "หมายเลขผู้ใช้งาน",
    charge: "หมายเลขที่คิดค่าใช้จ่าย",
    syncpackage: "ตรวจสอบแพ็คเกจ",
    create_success: "สร้างหมายเลขสำเร็จ",
    agent_create: "สร้างหมายเลขผู้ใช้งาน",
    pilot_create: "สร้างหมายเลของค์กร",
    pilot_create_success: "สร้างเบอร์องค์กรสำเร็จ",
    pilot_create_fail: "สร้างเบอร์องค์กรไม่สำเร็จ",
    agent_create_success: "สร้างเบอร์ผู้ใช้งานสำเร็จ",
    agent_create_fail: "สร้างเบอร์ผู้ใช้งานไม่สำเร็จ",
    bgadmin_login_fail: "ไม่สามารถเข้าสู่ระบบการตั้งค่าได้",
    comportal_login_fail: "ไม่สามารถเข้าสู่ระบบ Com Portal",
    sync_package_success: "ซิงค์ข้อมูลแพ็คเกจสำเร็จ",
    alternative: "หมายเลข Alternative",
    main_ivr: "Main IVR",
    real: "Real Number",
    mapping: "Mapping Number"
  },
  voicemail: {
    name: "ข้อความเสียง",
    called: "ถึง",
    caller: "จาก",
    date: "วันที่",
    corp: "องค์กร"
  },
  report: {
    chart_answer: "จำนวยสายที่รับ (คร้ง)",
    chart_abandon: "จำนวนสายที่ไม่ได้รับ (ครั้ง)",
    chart_talk_time_avg: "เวลาเฉลี่ยในการสนทนา (นาที)",
    chart_talk_time: "เวลาการสนทนารายวัน (นาที)",
    unit_call: " (ครั้ง)",
    unit_min: " (นาที)",

    inbound_answer: "จำนวนสายเรียกเข้า",
    inbound_abandon: "จำนวนสายที่ไม่ได้รับ",
    inbound_talk_time_avg: "เวลาเฉลี่ยในการสนทนา",
    inbound_talk_time: "เวลาการสนทนารายวัน",

    outbound_answer: "จำนวนสายโทรออก",
    outbound_abandon: "จำนวนสายที่ไม่ได้รับ",
    outbound_talk_time_avg: "เวลาเฉลี่ยในการสนทนา",
    outbound_talk_time: "เวลาการสนทนารายวัน",

    internal_answer: "จำนวนสายโทรภายใน",
    internal_abandon: "จำนวนสายภายในที่ไม่ได้รับ",
    internal_talk_time_avg: "เวลาเฉลี่ยในการสนทนา",
    internal_talk_time: "เวลาการสนทนารายวัน",

    menu: "ข้อมูลการโทร",
    charging_group: "Charging Group",
    export: "ส่งออก",
    duration: "เวลาใช้งาน",
    enterprise_number: "เบอร์องค์กร",
    number: "หมายเลข",
    enterprise: "ชื่อองค์กร",
    enterprise_sub: "สาขาย่อย",
    type: "ประเภท",
    cdr_report: "รายงานการใช้งานโทรศัพท์",
    dashboard_report: "รายงานสรุปภาพรวมการใช้งาน",
    performance_report_type: "ประเภทของรายงาน",
    performance_by_number: "ข้อมูลระดับผู้ใช้งาน",
    performance_by_group: "ข้อมูลระดับองค์กร",
    date: "วันที่",
    start: "วันที่เริ่มต้น",
    end: "วันที่สิ้นสุด",
    search: "ค้นหา",
    call_type: "ประเภทการโทร",
    outbound: "สายโทรออก",
    inbound: "สายโทรเข้า",
    internal: "สายที่โทรภายใน",
    voicemail: "ข้อความเสียง",
    all: "ทั้งหมด",
    call_status: "สถานะการโทร",
    status_answered: "รับสาย",
    status_no_answer: "ไม่ได้รับสาย",
    corporate: "องค์กร",
    call_dates: "วันที่",
    call_origination: "เบอร์ต้นทาง",
    display_number: "เบอร์ที่แสดง",
    call_termination: "เบอร์ปลายทาง",
    start_time: "เวลาที่เริ่ม",
    ringing: "ระยะเวลารอสาย (วินาที)",
    answered_time: "ระยะเวลารับสาย",
    terminated_time: "เวลาที่จบการสนทนา",
    terminated_reason: "เหตูผลที่จบการสนทนา",
    reason_change: "สาเหตุของการเปลี่ยนเบอร์สนทนา",
    final_number: "เบอร์ปลายทางที่ถูกโอนสายมา",
    duration: "ระยะเวลา (วินาที)",
    total_call: "จำนวน Transaction Log ทั้งหมด",
    answered: "จำนวนสายสนทนา (โทรออกและรับสาย) ทั้งหมด",
    unanswered:
      "จำนวนสายที่ไม่ได้รับทั้งหมดของสายเรียกเข้า, สายโทรออก และสายถึง Call Hunting Group",
    longest_waiting_time: "ระยะเวลารอสายที่นานที่สุด (รวมสายโทรออกและรับสาย)",
    avg_waiting_time: "ระยะเวลาเฉลี่ยที่เจ้าหน้าที่รอสาย  (วินาที)",
    avg_talk_time: "ค่าเฉลี่ยระยะเวลาสนทนาทั้งหมด (วินาที)",
    call_volume: "จำนวน Transaction Log ต่อวัน",
    number_of_calls: "จำนวนการโทรออกและการรับสาย (สาย)",
    talk_time: "ระยะเวลาสนทนารวมเชื่อมต่อ dtac OneCall ทั้งหมด",
    idle_time: "ระยะเวลาที่ว่างจากการสนทนา",
    speed_of_answer: "ความเร็วในรับสาย (วินาที)",
    status: "สถานะ",
    // date_warning: "ไม่สามารถค้นหาข้อมูลได้เกิน 60 วัน  และถ้าค้นหาข้อมูลมากกว่า 30 วันการค้นหาอาจจะเกิดความล่าช้า", 18_feb_2022
    // data_start : "ค้นหาข้อมูลย้อนหลังได้ถึง 60 วัน",
    date_warning:
      "ค้นหาข้อมูลย้อนหลังได้ถึง 90 วัน คำแนะนำเพื่อการแสดงผลที่รวดเร็ว ควรค้นหาข้อมูลไม่เกิน 30 วัน",
    data_start: "ระบบจะแสดงข้อมูลตั้งแต่วันที่ 25 กุมภาพันธ์ 2022 เป็นต้นไป",
    call_voicemail: "ข้อความเสียง (สาย)",
    no_number: "No Caller ID"
  },
  user: {
    create: "สร้างผู้ใช้งาน",
    name: "ชื่อ",
    username: "ชื่อผู้ใช้",
    phone: "เบอร์โทรศัพท์",
    role: "ระดับผู้ใช้งาน",
    type: "ประเภทผู้ใช้งาน",
    create_success: "สร้างผู้ใช้งานสำเร็จ",
    create_fail: "สร้างผู้ใช้งานไม่สำเร็จ"
  },
  mlhg: {
    name: "กลุ่ม Hunt",
    failed: "กลุ่ม Hunt ล้มเหลว",
    success: "กลุ่ม Hunt สำเร็จ",
    pilot_number: "หมายเลขนำหมู่",
    pilot_number_type: "ประเภทหมายเลขนำหมู่",
    pilot_number_dummy: "Dummy Number",
    pilot_number_real: "Real Number"
  },

  corporate_main: "องค์กรหลัก",
  group_name: "ชื่อกลุ่ม",
  email: "อีเมล์",
  email_optional: "อีเมล์ (ไม่ระบุ)",
  created: "วันที่สร้าง",
  search: "ค้นหา",
  save: "บันทึก",
  back: "กลับ",
  new: "สร้าง",
  status: "สถานะ",
  download: "ดาวน์โหลด",
  downloadall: "ดาวน์โหลดทั้งหมด",
  search: "ค้นหา",
  welcome: "ยินดีต้อนรับ",
  myprofile: "ข้อมูลส่วนตัว",
  changepassword: "เปลี่ยนรหัสผ่าน",
  page_notfound: "ขออภัย ไม่พบหน้าที่คุณต้องการ",
  page_notfound_desc:
    "หน้าดังกล่าวอาจมีการเปลี่ยนแปลง ชื่อ หรือ URL ไม่ถูกต้อง กรุณาตรวจสอบลิงค์ที่คุณเข้ามาอีกครั้ง",
  actions: "เมนู",
  data: "ข้อมูล",
  to: "ถึง",
  of: "จาก",
  row_select: "ข้อมูลที่ถูกเลือก",
  yes: "ใช่",
  no: "ไม่ใช่",
  ok: "ตกลง",
  cancel: "ยกเลิก",
  upload_file: "เพิ่มไฟล์",
  upload: "อัพโหลด",
  upload_number_success: "อัพโหลดหมายเลขผู้ใช้งานสำเร็จ",
  bg_admin: "ตั้งค่าผู้ดูแลระบบ",
  comportal: "ตั้งค่าผู้ใช้งาน",
  add: "เพิ่ม",
  import: "นำเข้า",
  clear: "ลบประวัติการนำเข้า",
  close: "ปิด",
  please_select: "กรุณาเลือก",
  create: "สร้าง",
  confirm: "ยืนยัน",
  create_success: "สร้างข้อมูลสำเร็จ",
  delete_confirm: "ยืนยันการลบข้อมูล",
  delete_confirm_text: "คุณต้องการลบข้อมูล ",
  delete_confirm_question: "คุณต้องการลบข้อมูล ",
  delete_success: "ลบข้อมูลสำเร็จ",
  delete_fail: "ลบข้อมูลไม่สำเร็จ",
  edit_success: "แก้ไขข้อมูลสำเร็จ",
  edit_fail: "แก้ไขข้อมูลไม่สำเร็จ",
  import_inprogress: "กำลังประมวลผล กรุณาตรวจสอบสถานะ",
  processing: "กำลังประมวลผล กรุณารอสักครู่"
};
